const STYLES = {
  button: {
    padding: '5px 10px',
    fontSize: '13px',
    color: '#777777'
  }
};
export default STYLES;